import React from "react";

export default () => {
  const randomId = "protection_lock_" + Math.random();
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.60018 6.59853C3.51464 6.7538 2.68018 7.68738 2.68018 8.81585V12.9758C2.68018 14.213 3.68306 15.2158 4.92018 15.2158H11.0802C12.3173 15.2158 13.3202 14.213 13.3202 12.9758V8.81585C13.3202 7.74349 12.5666 6.84713 11.5602 6.62739V5.09584C11.5602 3.17389 10.0021 1.61584 8.08018 1.61584C6.15822 1.61584 4.60018 3.17389 4.60018 5.09584V6.59853ZM5.56018 6.57585H10.6002V5.09584C10.6002 3.70409 9.47193 2.57584 8.08018 2.57584C6.68842 2.57584 5.56018 3.70409 5.56018 5.09584V6.57585ZM7.64018 8.97585V12.9758C7.64018 13.1526 7.78344 13.2958 7.96018 13.2958C8.13691 13.2958 8.28018 13.1526 8.28018 12.9758V8.97585C8.28018 8.79911 8.13691 8.65585 7.96018 8.65585C7.78344 8.65585 7.64018 8.79911 7.64018 8.97585Z"
        fill="#333333"
      />
      <mask
        id={randomId}
        maskUnits="userSpaceOnUse"
        x="2"
        y="1"
        width="12"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.60018 6.59853C3.51464 6.7538 2.68018 7.68738 2.68018 8.81585V12.9758C2.68018 14.213 3.68306 15.2158 4.92018 15.2158H11.0802C12.3173 15.2158 13.3202 14.213 13.3202 12.9758V8.81585C13.3202 7.74349 12.5666 6.84713 11.5602 6.62739V5.09584C11.5602 3.17389 10.0021 1.61584 8.08018 1.61584C6.15822 1.61584 4.60018 3.17389 4.60018 5.09584V6.59853ZM5.56018 6.57585H10.6002V5.09584C10.6002 3.70409 9.47193 2.57584 8.08018 2.57584C6.68842 2.57584 5.56018 3.70409 5.56018 5.09584V6.57585ZM7.64018 8.97585V12.9758C7.64018 13.1526 7.78344 13.2958 7.96018 13.2958C8.13691 13.2958 8.28018 13.1526 8.28018 12.9758V8.97585C8.28018 8.79911 8.13691 8.65585 7.96018 8.65585C7.78344 8.65585 7.64018 8.79911 7.64018 8.97585Z"
          fill="white"
        />
      </mask>
      <g mask={`url(#${randomId})`}>
        <rect y="0.5" width="16" height="16" fill="white" />
      </g>
    </svg>
  );
};
